import React from "react";
import { Construction } from "lucide-react";

export default function UnderDevelopment({ title, eta = "Phase 1b–1f", description }) {
  return (
    <div data-testid="under-development" style={{ padding: 48, maxWidth: 720, margin: "0 auto" }}>
      <div className="card" style={{ padding: 32, borderLeft: "6px solid var(--brand-accent, #F05A14)", textAlign: "left" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 12 }}>
          <Construction size={32} style={{ color: "var(--brand-accent, #F05A14)" }} />
          <div>
            <div className="mono" style={{ color: "var(--brand-accent, #F05A14)", fontWeight: 600, fontSize: 12, letterSpacing: "0.1em" }}>UNDER DEVELOPMENT</div>
            <h1 style={{ fontSize: 26, fontWeight: 900, margin: "2px 0 0" }} data-testid="ud-title">{title}</h1>
          </div>
        </div>
        <p style={{ color: "#475569", lineHeight: 1.6, marginTop: 12 }}>
          {description || `The ${title} module is on the Phase 1 roadmap and will be activated in a subsequent build pass. Data already captured elsewhere in the system will feed it the moment it goes live — no double-entry required.`}
        </p>
        <div className="mono" style={{ marginTop: 18, fontSize: 11, color: "#94a3b8" }}>
          Planned activation · {eta}
        </div>
      </div>
    </div>
  );
}
